import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { BehaviorSubject, Observable, of, tap } from 'rxjs'
import { IAuthInfo, ILoginRequest } from '../model/interfaces'
import { environment } from '../../environments/environment'
import { Router } from '@angular/router'
import { catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  #authInfo$: BehaviorSubject<IAuthInfo | null> = new BehaviorSubject<IAuthInfo | null>(null)
  redirectUrl = ''

  get isAuthorized() {
    return localStorage.getItem('accessToken')
  }

  constructor(private http: HttpClient, private router: Router) {}

  login(loginData: ILoginRequest): Observable<IAuthInfo> {
    return this.http.post<IAuthInfo>(`${environment.baseUrl}login/auth`, loginData).pipe(
      tap(authInfo => {
        this.#authInfo$.next(authInfo)
        localStorage.setItem('accessToken', authInfo.access_token)
        localStorage.setItem('login', loginData.login)
        localStorage.setItem('refreshToken', authInfo.refresh_token)
        console.log('logged in', this.redirectUrl)
        this.router.navigate([this.redirectUrl ? this.redirectUrl : '/main'])
      })
    )
  }

  refreshToken(): Observable<IAuthInfo | boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'isRefreshTokenRequest': 'true',
      }),
    }

    return this.http
      .post<IAuthInfo>(
        `${environment.baseUrl}auth/refresh`,
        {
          refreshToken: localStorage.getItem('refreshToken'),
        },
        httpOptions
      )
      .pipe(
        tap(authInfo => {
          if (authInfo) {
            this.#authInfo$.next(authInfo)
            localStorage.setItem('accessToken', authInfo.access_token)
            localStorage.setItem('refreshToken', authInfo.refresh_token)
          }
        }),
        catchError(() => {
          this.logout()
          return of(false)
        })
      )
  }

  logout(): void {
    this.clearTokens()
    this.router.navigate(['/login']).then()
  }

  getJwtToken(): string {
    return localStorage.getItem('accessToken') || ''
  }

  clearTokens(): void {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
  }
}
